
import { links } from "../data/links";
import React, {ReactElement, FC} from "react";
import "./styles/Links.css"


const Links: FC<any> = (): ReactElement => {
return (
    <section id="links" className="links-section-container">
        <div className="links-container">
        <div className="links-title-container">
            <h1 className="link-title-wrapper">
                Other Related Links 
            </h1>
            <p className="links-text-wrapper">
                The following sites are links to other important websites
            </p>
        </div>
        <div className="links-content-container">
            <ul>
            {links.map((project) => (
                <li><div className="link-container">
                    <img
                    alt="gallary"
                    className="link-content-image"
                    src={project.image}
                    width={project.size}
                    height={project.size}
                />
                    <a
                    href={project.link}
                    key={project.image}
                    title={project.hover_description}
                    className="links-link">
                        {project.title}
                    </a>
                </div>
                </li>
            ))}
        </ul>
        </div>
    </div>
    </section>
);
}

export default Links;